import { useEffect, useState } from "react";
import API from "../services/api";

export default function Staff() {
    const [staffList, setStaffList] = useState([]);
    const [staffSummary, setStaffSummary] = useState({
        totalStaff: 0,
        totalMonthlySalary: 0
    });

    const [search, setSearch] = useState("");
    const [editingStaff, setEditingStaff] = useState(null);

    const [showEditModal, setShowEditModal] = useState(false);
    const [formErrors, setFormErrors] = useState({});


    const [form, setForm] = useState({
        name: "",
        role: "",
        phone: "",
        email: "",
        salary: ""
    });

    const fetchStaff = async () => {
        try {
            const res = await API.get("/staff");
            setStaffList(res.data);
        } catch (err) {
            alert("Unable to fetch staff");
        }
    };

    const fetchStaffSummary = async () => {
        try {

            const res = await API.get(
                "/staff/summary"
            );

            setStaffSummary(res.data);

        } catch (err) {

            console.log(
                "Unable to fetch staff summary",
                err
            );

        }
    };

    useEffect(() => {
        fetchStaff();
        fetchStaffSummary();
    }, []);

    const handleAddStaff = async () => {

        try {

            const errors = {};

            if (!form.name.trim()) {
                errors.name = true;
            }

            if (!form.role.trim()) {
                errors.role = true;
            }

            if (!form.phone.trim()) {
                errors.phone = true;
            }

            if (
                !form.salary ||
                Number(form.salary) <= 0
            ) {
                errors.salary = true;
            }

            if (form.email.trim()) {

                const emailRegex =
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (!emailRegex.test(form.email)) {
                    errors.email = true;
                }

            }

            setFormErrors(errors);

            if (Object.keys(errors).length > 0) {

                alert(
                    "Please complete the required staff fields."
                );

                return;
            }

            await API.post("/staff/add", form);


            alert("Staff added successfully");

            setForm({
                name: "",
                role: "",
                phone: "",
                email: "",
                salary: "",
                status: "Active"
            });

            fetchStaff();
            fetchStaffSummary();
        } catch (err) {

            alert("Failed to add staff");

        }

    };


    const handleUpdateStaff = async () => {

        try {

            await API.put(
                `/staff/update/${editingStaff.id}`,
                editingStaff
            );

            alert("Staff updated successfully");

            setShowEditModal(false);

            setEditingStaff(null);

            fetchStaff();
            fetchStaffSummary();

        } catch (err) {

            console.log(err);

            alert("Unable to update staff");

        }

    };


    const handleToggleStaffStatus = async (staff) => {
        const isActive = (staff.status || "Active") === "Active";

        const action = isActive ? "deactivate" : "activate";

        const confirmed = window.confirm(
            isActive
                ? `Are you sure you want to deactivate '${staff.name}'?

Their salary history will be preserved.`
                : `Do you want to activate '${staff.name}' again?`
        );

        if (!confirmed) {
            return;
        }

        try {
            const res = await API.delete(
                `/staff/delete/${staff.id}`
            );

            alert(
                res.data?.message ||
                (isActive
                    ? "Staff deactivated successfully"
                    : "Staff activated successfully")
            );

            await fetchStaff();
            await fetchStaffSummary();

        } catch (err) {
            console.log("CHANGE STAFF STATUS ERROR:", err);
            console.log(
                "SERVER RESPONSE:",
                err.response?.data
            );

            alert(
                err.response?.data?.message ||
                `Unable to ${action} staff`
            );
        }
    };


    const filteredStaff = staffList.filter((staff) =>
        (staff.name || "")
            .toLowerCase()
            .includes(search.toLowerCase()) ||

        (staff.role || "")
            .toLowerCase()
            .includes(search.toLowerCase()) ||

        (staff.status || "Active")
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">
                Staff Management
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">

                {/* Total Staff */}

                <div className="bg-white shadow rounded-xl p-6">

                    <p className="text-gray-500 text-sm font-semibold">
                        TOTAL STAFF
                    </p>

                    <p className="text-3xl font-bold mt-2">
                        {staffSummary.totalStaff || 0}
                    </p>

                    <p className="text-sm text-gray-500 mt-1">
                        Total Staff Members
                    </p>

                </div>


                {/* Total Monthly Salary */}

                <div className="bg-white shadow rounded-xl p-6">

                    <p className="text-gray-500 text-sm font-semibold">
                        TOTAL MONTHLY SALARY
                    </p>

                    <p className="text-3xl font-bold mt-2">
                        ₹{Number(
                            staffSummary.totalMonthlySalary || 0
                        ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    </p>

                    <p className="text-sm text-gray-500 mt-1">
                        Total Monthly Salary Cost
                    </p>

                </div>

            </div>

            <div className="bg-white shadow p-6 rounded mb-6">

                <div className="mb-3">

                    <label className="block mb-1 font-semibold">
                        Staff Name <span className="text-red-600">*</span>
                    </label>

                    <input
                        type="text"
                        placeholder="Enter staff name"
                        value={form.name}
                        onChange={(e) => {

                            setForm({
                                ...form,
                                name: e.target.value
                            });

                            setFormErrors(prev => ({
                                ...prev,
                                name: false
                            }));

                        }}
                        className={`border p-2 w-full rounded ${formErrors.name
                            ? "border-red-500 bg-red-50"
                            : "border-gray-300"
                            }`}
                    />

                    {formErrors.name && (
                        <p className="text-red-600 text-sm mt-1">
                            Staff name is required
                        </p>
                    )}

                </div>

                <div className="mb-3">

                    <label className="block mb-1 font-semibold">
                        Role <span className="text-red-600">*</span>
                    </label>

                    <input
                        type="text"
                        placeholder="e.g. Teacher, Accountant"
                        value={form.role}
                        onChange={(e) => {

                            setForm({
                                ...form,
                                role: e.target.value
                            });

                            setFormErrors(prev => ({
                                ...prev,
                                role: false
                            }));

                        }}
                        className={`border p-2 w-full rounded ${formErrors.role
                            ? "border-red-500 bg-red-50"
                            : "border-gray-300"
                            }`}
                    />

                    {formErrors.role && (
                        <p className="text-red-600 text-sm mt-1">
                            Role is required
                        </p>
                    )}

                </div>

                <div className="mb-3">

                    <label className="block mb-1 font-semibold">
                        Phone <span className="text-red-600">*</span>
                    </label>

                    <input
                        type="tel"
                        placeholder="Enter phone number"
                        value={form.phone}
                        onChange={(e) => {

                            setForm({
                                ...form,
                                phone: e.target.value
                            });

                            setFormErrors(prev => ({
                                ...prev,
                                phone: false
                            }));

                        }}
                        className={`border p-2 w-full rounded ${formErrors.phone
                            ? "border-red-500 bg-red-50"
                            : "border-gray-300"
                            }`}
                    />

                    {formErrors.phone && (
                        <p className="text-red-600 text-sm mt-1">
                            Phone number is required
                        </p>
                    )}

                </div>

                <input
                    placeholder="Email"
                    value={form.email}
                    onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                    }
                    className="border p-2 mb-3 w-full"
                />

                <div className="mb-3">

                    <label className="block mb-1 font-semibold">
                        Monthly Salary (₹){" "}
                        <span className="text-red-600">*</span>
                    </label>

                    <input
                        type="number"
                        min="1"
                        placeholder="Enter monthly salary"
                        value={form.salary}
                        onChange={(e) => {

                            setForm({
                                ...form,
                                salary: e.target.value
                            });

                            setFormErrors(prev => ({
                                ...prev,
                                salary: false
                            }));

                        }}
                        className={`border p-2 w-full rounded ${formErrors.salary
                            ? "border-red-500 bg-red-50"
                            : "border-gray-300"
                            }`}
                    />

                    {formErrors.salary && (
                        <p className="text-red-600 text-sm mt-1">
                            Monthly salary is required
                        </p>
                    )}

                </div>

                <button
                    onClick={handleAddStaff}
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                    Add Staff
                </button>

            </div>

            <div className="bg-white shadow p-6 rounded">

                <input
                    type="text"
                    placeholder="Search by Staff Name or Role"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="border p-2 mb-4 w-full"
                />

                <table className="w-full border">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="p-3 text-left">Name</th>
                            <th className="p-3 text-left">Role</th>
                            <th className="p-3 text-left">Phone</th>
                            <th className="p-3 text-left">Email</th>
                            <th className="p-3 text-center">Salary</th>
                            <th className="p-3 text-center">Status</th>
                            <th className="p-3 text-center">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredStaff.map((staff) => (
                            <tr key={staff.id}>
                                <td>{staff.name}</td>
                                <td>{staff.role}</td>
                                <td>{staff.phone}</td>
                                <td>{staff.email}</td>
                                <td className="p-3 text-center">
                                    ₹{Number(staff.salary || 0).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </td>

                                <td className="p-3 text-center">
                                    <span
                                        className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold ${(staff.status || "Active") === "Active"
                                                ? "bg-green-100 text-green-700"
                                                : "bg-gray-200 text-gray-600"
                                            }`}
                                    >
                                        {staff.status || "Active"}
                                    </span>
                                </td>

                                <td className="p-3 text-center">

                                    <div className="flex justify-center gap-2">

                                        <button
                                            onClick={() => {

                                                setEditingStaff({
                                                    ...staff,
                                                    status: staff.status || "Active"
                                                });

                                                setShowEditModal(true);

                                            }}
                                            className="bg-yellow-100 hover:bg-yellow-200 text-yellow-700 px-3 py-1 rounded-lg text-sm font-semibold"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() =>
                                                handleToggleStaffStatus(staff)
                                            }
                                            className={`px-3 py-1 rounded-lg text-sm font-semibold ${(staff.status || "Active") === "Active"
                                                    ? "bg-red-100 hover:bg-red-200 text-red-700"
                                                    : "bg-green-100 hover:bg-green-200 text-green-700"
                                                }`}
                                        >
                                            {(staff.status || "Active") === "Active"
                                                ? "Deactivate"
                                                : "Activate"}
                                        </button>

                                    </div>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showEditModal && editingStaff && (

                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

                    <div className="bg-white rounded-3xl p-8 w-[600px] shadow-2xl">

                        {/* Header */}

                        <div className="flex justify-between items-center mb-6">

                            <div>

                                <h2 className="text-2xl font-bold">
                                    Edit Staff
                                </h2>

                                <p className="text-gray-500 text-sm">
                                    Update staff details and salary
                                </p>

                            </div>

                            <button
                                onClick={() => {

                                    setShowEditModal(false);
                                    setEditingStaff(null);

                                }}
                                className="text-red-500 text-xl font-bold"
                            >
                                ✕
                            </button>

                        </div>


                        {/* Form */}

                        <div className="grid grid-cols-2 gap-4">

                            {/* Name */}

                            <div>

                                <label className="block mb-2 font-semibold">
                                    Staff Name
                                </label>

                                <input
                                    type="text"
                                    value={editingStaff.name || ""}
                                    onChange={(e) =>
                                        setEditingStaff({
                                            ...editingStaff,
                                            name: e.target.value
                                        })
                                    }
                                    className="border p-3 rounded-xl w-full"
                                />

                            </div>


                            {/* Role */}

                            <div>

                                <label className="block mb-2 font-semibold">
                                    Role
                                </label>

                                <input
                                    type="text"
                                    value={editingStaff.role || ""}
                                    onChange={(e) =>
                                        setEditingStaff({
                                            ...editingStaff,
                                            role: e.target.value
                                        })
                                    }
                                    className="border p-3 rounded-xl w-full"
                                />

                            </div>


                            {/* Phone */}

                            <div>

                                <label className="block mb-2 font-semibold">
                                    Phone
                                </label>

                                <input
                                    type="text"
                                    value={editingStaff.phone || ""}
                                    onChange={(e) =>
                                        setEditingStaff({
                                            ...editingStaff,
                                            phone: e.target.value
                                        })
                                    }
                                    className="border p-3 rounded-xl w-full"
                                />

                            </div>


                            {/* Email */}

                            <div>

                                <label className="block mb-2 font-semibold">
                                    Email
                                </label>

                                <input
                                    type="email"
                                    value={editingStaff.email || ""}
                                    onChange={(e) =>
                                        setEditingStaff({
                                            ...editingStaff,
                                            email: e.target.value
                                        })
                                    }
                                    className="border p-3 rounded-xl w-full"
                                />

                            </div>


                            {/* Salary */}

                            <div className="col-span-2">

                                <label className="block mb-2 font-semibold">
                                    Monthly Salary
                                </label>

                                <input
                                    type="number"
                                    min="0"
                                    value={editingStaff.salary || ""}
                                    onChange={(e) =>
                                        setEditingStaff({
                                            ...editingStaff,
                                            salary: e.target.value
                                        })
                                    }
                                    className="border p-3 rounded-xl w-full"
                                />

                            </div>

                            {/* Status */}

                            <div className="col-span-2">

                                <label className="block mb-2 font-semibold">
                                    Staff Status
                                </label>

                                <select
                                    value={editingStaff.status || "Active"}
                                    onChange={(e) =>
                                        setEditingStaff({
                                            ...editingStaff,
                                            status: e.target.value
                                        })
                                    }
                                    className="border p-3 rounded-xl w-full"
                                >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>

                                <p className="text-xs text-gray-500 mt-1">
                                    Inactive staff remain in salary history and financial records.
                                </p>

                            </div>

                        </div>


                        {/* Buttons */}

                        <div className="flex justify-end gap-3 mt-6">

                            <button
                                onClick={() => {

                                    setShowEditModal(false);
                                    setEditingStaff(null);

                                }}
                                className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-3 rounded-xl font-semibold"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={handleUpdateStaff}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-semibold"
                            >
                                Save Changes
                            </button>

                        </div>

                    </div>

                </div>

            )}

        </div>
    );
}